/**
 * QA Forms
 */
export const QA = (function () {

  var form = {

      build: function (form_name) {

          var array = [];
          var groupid = { "id": form_name, "name": form_name, "complete": "false" };
          var formName = form_name;

          groupid = JSON.stringify(groupid);
          var i = 0;

          var survey_id = document.querySelector('.survey').id;

          // Get PDS transactional dataset fields and also store to the QA form
          $('.qa-pds-dataset').each(function () {

              if (this.type != 'hidden' ) {

                  var obj = QA.form.format(groupid, formName, this, i, 'text');
                  i++;
                  array.push(obj);
              }
          });

          // Get all QA specific Form fields (eg fields for which we do not have a dataset)
          $('.qa-field').each(function () {

              if (this.type != 'hidden' ) {

                  var obj = QA.form.format(groupid, formName, this, i, 'text');
                  i++;
                  array.push(obj);
              }
          });

          $('.qa-declared').each(function () {


              var answer = this.checked;
              var label = this.name;

              var qFormat = {
                  "question_set_name": survey_id,
                  "question_set_id": formName + i,
                  "name": "",
                  "type": 'checkbox_declaration',
                  "top_level_question": "",
                  "sub_question_id": "",
                  "sub_question_sequence": "",
                  "form": true,
                  "formOrder": '',
                  "formId": this.id,
                  "answer_options": [],
              }
  
              var qv_history = {
                  "version": "0",
                  "version_content": "",
                  "version_change_description": ""
              }
  
              // Stringify the object (where we store blob metadata)
              qv_history = JSON.stringify(qv_history);
              qFormat = JSON.stringify(qFormat);
  
              var obj = {
                  "group_id": groupid,
                  "question_id": formName + i,
                  "question_label": label,
                  "answer_result": answer,
                  "question_timestamp": Date.now(),
                  "question_set_format": qFormat,
                  "question_tags": "",
                  "con_id": "",
                  "question_version_history": qv_history,
                  "question_version_id": "0",
                  "answer_version_history": "23",
                  "answer_version_id": "",
                  "answer_question_version": "",
                  "answer_timestamp": "",
              }
              i++;
              array.push(obj);
         
          });

          /**
           * Function to loop through each QA element in the form and parse into question objects
           */
          $('.qa-radio').each(function () {

              var answer_options = [];
              var label = this.children[0].innerText;
              // Loop through the child elements for the answer options

              var answer_result;
              var answer_option_radio;
              for (var j = 1; j < this.children.length; j++) {

                if (this.children[j].children.length != 0) {
                    answer_options.push(this.children[j].innerText);
                    var answer_result_temp = '';

                    if (this.children[j].innerText === 'Other') {
                        
                        // find the text inside the textarea - we want to save the format as {Other:The text here}
                        var text_value = $(this).find('textarea')[0].value;
                        answer_result_temp = this.children[j].innerText + ":" + text_value;
                        
                    } else {
                        answer_result_temp = this.children[j].innerText;

                    }
                    answer_options.push(this.children[j].innerText);
                    if (this.children[j].children[0].checked === true) {
                        answer_result = answer_result_temp;
                        answer_option_radio = this.children[j].children[0].value;
                    }
                }

              }

             // var obj = QA.form.format(groupid, formName, this, i, 'radio');


              var qFormat = {
                  "question_set_id": survey_id,
                  "question_set_name": "",
                  "name": "",
                  "type": "radio",
                  "top_level_question": "",
                  "sub_question_id": "",
                  "sub_question_sequence": "",
                  "answer_options": answer_options,
                  "form": true,
                  "formId": this.id,
                  "answer_option_radio": answer_option_radio
              }


              var qv_history = {
                  "version": "0",
                  "version_content": "",
                  "version_change_description": ""
              }

              qv_history = JSON.stringify(qv_history);

              if (answer_result === undefined){
                  answer_result = '';
              }

              qFormat = JSON.stringify(qFormat);
              var obj = {
                  "group_id": groupid,
                  "question_id": formName + i,
                  "question_label": label,
                  "question_timestamp": Date.now(),
                  "question_set_format": qFormat,
                  "question_tags": "",
                  "con_id": "",
                  "question_version_history": qv_history,
                  "question_version_id": "0",
                  "answer_version_history": "23",
                  "answer_version_id": "",
                  "answer_question_version": "",
                  "answer_timestamp": "",
                  "answer_result": answer_result
              }
              i++;


              array.push(obj);
          });

          /**
           * Function to loop through each QA element in the form and parse into question objects
           */
          $('.qa-checkbox').each(function () {

              var answer_options = [];
              var label = this.children[0].innerText;
              // Loop through the child elements for the answer options

              var answer_result = [];
              var answer_option_radio = [];
              for (var j = 1; j < this.children.length; j++) {

                if (this.children[j].children.length != 0) {
                    answer_options.push(this.children[j].innerText);
                    var answer_result_temp = '';

                    if (this.children[j].innerText === 'Other') {
                        
                        // find the text inside the textarea - we want to save the format as {Other:The text here}
                        var text_value = $(this).find('textarea')[0].value;
                        answer_result_temp = this.children[j].innerText + ":" + text_value;
                        
                    } else {
                        answer_result_temp = this.children[j].innerText;

                    }
                    answer_options.push(this.children[j].innerText);
                    if (this.children[j].children[0].checked === true) {
                        answer_result.push(answer_result_temp);
                        answer_option_radio.push(this.children[j].children[0].value);
                    }
                }
              }

              answer_result = JSON.stringify(answer_result);
              answer_option_radio = JSON.stringify(answer_option_radio);

              var qFormat = {
                  "question_set_id": survey_id,
                  "question_set_name": "",
                  "name": "",
                  "type": "checkbox",
                  "top_level_question": "",
                  "sub_question_id": "",
                  "sub_question_sequence": "",
                  "answer_options": answer_options,
                  "form": true,
                  "formId": this.id,
                  "answer_option_radio": answer_option_radio
              }

              var qv_history = {
                  "version": "0",
                  "version_content": "",
                  "version_change_description": ""
              }

              qv_history = JSON.stringify(qv_history);

              if (answer_result === undefined){
                  answer_result = '';
              }

              qFormat = JSON.stringify(qFormat);
              var obj = {
                  "group_id": groupid,
                  "question_id": formName + i,
                  "question_label": label,
                  "question_timestamp": Date.now(),
                  "question_set_format": qFormat,
                  "question_tags": "",
                  "con_id": "",
                  "question_version_history": qv_history,
                  "question_version_id": "0",
                  "answer_version_history": "23",
                  "answer_version_id": "",
                  "answer_question_version": "",
                  "answer_timestamp": "",
                  "answer_result": answer_result
              }
              i++;
              array.push(obj);

          });

          var requests = [];
          requests.push( PDS.pds.post('ds_questions_answers', array) );

          return requests;
      },

      /**
       * Retrieves QA datset from the PDS and builds it into a form
       */
      load: function () {
          var mydexID = Util.getPathParameterByName('citizen');
          var pds_data = PDS.pds.get('ds_questions_answers', mydexID);
          var survey_id = document.querySelector('.survey').id;

          pds_data.then(function (response) {

              var array = [];
              for (let key in response) {
                  array.push(response[key]);
              }

              var questions = QA.helpers.getAll(array);

              for (let k in questions) {

                  var qFormat = JSON.parse(questions[k].question_set_format);

                  // for legacy/older accounts - previously we were not correctly setting
                  // the insight id into the question set - we did however set the surevy id into
                  // the name (part of the group_id json values) - use this value in the OR below to load older surveys
                  var survey_id_int = survey_id.split('-')[1];
                  var group_id = JSON.parse(questions[k].group_id);

                  // Only use the questions related to this question set - or legacy see above
                  if (qFormat.question_set_id === survey_id || survey_id_int === group_id.name ) {

                      if (qFormat.type === 'checkbox') {

                          // get all inputs in this div
                          var inputs = $('#' + qFormat.formId).find(':input');

                          var answerArray = JSON.parse(qFormat.answer_option_radio);

                          // Find all input elements in radio and set the correct answer
                          for (var i = 0; i < inputs.length; i++) {
                              for (var j = 0; j < answerArray.length; j++) {
                                  if (inputs[i].value === answerArray[j]) {

                                      inputs[i].checked = true;

                                      document.getElementById(inputs[i].id).checked = true;
                                                                        // If it's type other we want to get the extra text and set it into the textarea
                                    if (inputs[i].value === 'Other') {
                                        var textContent = questions[k].answer_result.split(/:|"]/);
                                        var textarea = inputs.parent().find('textarea')[0];
                                        textarea.value = textContent[1];
                                    }
                                  }
                              }

                          }
                      } else if (qFormat.type === 'radio') {
                          questions[k].answer_result

                          // get all inputs in this div
                          var inputs = $('#' + qFormat.formId).find(':input');

                          // Find all input elements in radio and set the correct answer
                          for (var i = 0; i < inputs.length; i++) {
                              if (inputs[i].value === qFormat.answer_option_radio) {

                                  inputs[i].checked = true;
                                  document.getElementById(inputs[i].id).checked = true;

                                  // If it's type other we want to get the extra text and set it into the textarea
                                  if (inputs[i].value === 'Other') {
                                    var textContent = questions[k].answer_result.split(":");
                                    var textarea = inputs.parent().find('textarea')[0];
                                    textarea.value = textContent[1];
                                  }
                              }
                          }

                      } else if (qFormat.type === 'checkbox_declaration') {


                          if (document.getElementById(qFormat.formId)) {

                              document.getElementById(qFormat.formId).checked = questions[k].answer_result;
                          }

                      }

                      if (document.getElementById(qFormat.formId)) {
                          document.getElementById(qFormat.formId).value = questions[k].answer_result;
                      }

                  }


              }

          })
      },

      /**
       * Format a question ready to be written to QA in the PDS
       */
      format: function (groupid, formName, el, i, type, answer_result = null, answer_options = null) {

          // Get the parent elements
          var label_parent = el.parentNode;
          var label = label_parent.children[0].innerText;

          var qFormat = {
              "question_set_name": "",
              "question_set_id": formName + i,
              "name": "",
              "type": type,
              "top_level_question": "",
              "sub_question_id": "",
              "sub_question_sequence": "",
              "answer_options": "",
              "form": true,
              "formOrder": $(el).attr("data-order"),
              "formId": el.id
          }

          var qv_history = {
              "version": "0",
              "version_content": "",
              "version_change_description": ""
          }

          // Stringify the object (where we store blob metadata)
          qv_history = JSON.stringify(qv_history);
          qFormat = JSON.stringify(qFormat);


          var answer = document.getElementById(el.id).value;

          var obj = {
              "group_id": groupid,
              "question_id": formName + i,
              "question_label": label,
              "answer_result": answer,
              "question_timestamp": Date.now(),
              "question_set_format": qFormat,
              "question_tags": "",
              "con_id": "",
              "question_version_history": qv_history,
              "question_version_id": "0",
              "answer_version_history": "23",
              "answer_version_id": "",
              "answer_question_version": "",
              "answer_timestamp": "",
          }
          i++;


          return obj;

      },

      testMe: function () {

          // alert('worked');

          QA.helpers.getAll([]);
      }




  };

  var helpers = {

      /**
       * return an array of all questions using only the latest versions
       * @param {*} questionsArray 
       */
      getAll: function (questionsArray) {

          var questions = [];

          var groupMap = new Map();

          questionsArray.forEach(question => {

              //Check group_id in map keys, ? push to the values array : create map entry 
              if (question.group_id !== "") {
                  if (groupMap.has(question.group_id)) {


                      groupMap.get(question.group_id).push(question);
                  } else {
                      groupMap.set(question.group_id, new Array());
                  }
              }
          });

          // add all questions with same questionid into array and then sort that by id - take the latest
          // get all unique question IDs
          var uniqueQuestions = questionsArray.map(item => item.question_id).filter((value, index, self) => self.indexOf(value) === index);


          for (var k in uniqueQuestions) {

              questions.push(QA.helpers.getLatest(questionsArray, uniqueQuestions[k]));
          }

          return questions;

      },
      /**
       * Helper method
       * Returns the most recent version of a single questions
       */
      getLatest: function (questionsArray, questionID) {

          var versions = []

          for (var k in questionsArray) {

              if (questionsArray[k].question_id === questionID) {
                  versions.push(questionsArray[k]);
              }
          }

          return versions.slice(-1)[0];

      }

  }

  return {
      form: form,
      helpers: helpers
  }

}());

